import { QuestionCircleOutlined } from "@ant-design/icons";
import {
	EnvironmentOutlined,
	FileTextOutlined,
	HistoryOutlined,
	HomeOutlined,
	LoginOutlined,
	LogoutOutlined,
	InboxOutlined,
	UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { ROLES } from "./permissions";

export const routes = {
	home: {
		key: "home",
		slug: "home",
		to: "/home",
		title: "Comunicación incidencias",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	emtRequests: {
		key: "emtRequests",
		slug: "emtRequests",
		to: "/emtRequests",
		title: "Ordenes de trabajo EMT",
		icon: <FileTextOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},


	incidenciasHistorial: {
		key: "incidenciasHistorial",
		slug: "incidenciasHistorial",
		to: "/incidenciasHistorial",
		title: "Historial incidencias",
		icon: <HistoryOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	pendingIncidences: {
		key: "pendingIncidences",
		slug: "pendingIncidences",
		to: "/pendingIncidences",
		title: "Incidencias pendientes",
		icon: <InboxOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
		requiresCanCreateIncidences: true,
	},

	peticionesHistorial: {
		key: "peticionesHistorial",
		slug: "peticionesHistorial",
		to: "/peticionesHistorial",
		title: "Historial ordenes de trabajo",
		icon: <HistoryOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	map: {
		key: "map",
		slug: "map",
		to: "/map",
		title: "Mapa",
		icon: <EnvironmentOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	profile: {
		key: "profile",
		slug: "profile",
		to: "/profile",
		title: "Perfil",
		icon: <UserOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	users: {
		key: "users",
		slug: "users",
		to: "/users",
		title: "Usuarios",
		icon: <UserOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},

	login: {
		key: "login",
		slug: "login",
		to: "/login",
		title: "LOGIN",
		icon: <LoginOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	questions: {
		key: "questions",
		slug: "questions",
		to: "/questions",
		title: "Conf. Incidencias",
		icon: <QuestionCircleOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},


	requestQuestions: {
		key: "requestQuestions",
		slug: "requestQuestions",
		to: "/requestQuestions",
		title: "Conf. Ordenes",
		icon: <QuestionCircleOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},

	logout: {
		key: "logout",
		slug: "logout",
		to: "/logout",
		title: "Log out",
		icon: <LogoutOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},
};
